export enum PortalRoutes {
    Dashboard = "/dashboard",
    Products = "/products",
    Orders = "/orders",
    Reports = "/reports",
} 